import { Component } from '@angular/core';
import { LangSwitchComponent as BaseComponent } from '../../../../../app/shared/lang-switch/lang-switch.component';

@Component({
  selector: 'ds-lang-switch',
  // styleUrls: ['./lang-switch.component.scss'],
  styleUrls: ['../../../../../app/shared/lang-switch/lang-switch.component.scss'],
  // templateUrl: './lang-switch.component.html',
  templateUrl: '../../../../../app/shared/lang-switch/lang-switch.component.html',
})
export class LangSwitchComponent extends BaseComponent {
}
